<template>
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M10 2.5V6.78571M10 2.5H16C16.8284 2.5 17.5 3.17157 17.5 4V16C17.5 16.8284 16.8284 17.5 16 17.5H4C3.17157 17.5 2.5 16.8284 2.5 16V13.2143M10 2.5H4C3.17157 2.5 2.5 3.17157 2.5 4V13.2143M10 17.5V13.2143M10 6.78571H17.5M10 6.78571V13.2143M10 13.2143H2.5" stroke="currentColor" stroke-width="1.25"/>
    </svg>
</template>
